import $ from 'jquery';
import { gsap } from 'gsap';

import { $Elements, Animations, Breakpoints, Classes, Durations, Events } from '../global/constants';
import { isTouchScreen } from '../global/helpers';

// ---------- Init Base Animation ----------

export const initBaseAnimations = () => {

	// ---------- Scrolling Text ----------

	$('.footer-link .content').each(function() {

		Animations.global.push(() => {

			gsap.to(this, {
				duration: 10,
				ease: 'none',
				x: "-=20%",
				repeat: -1
			});
		});
	});

	// ---------- Home Introduction ----------

	$('.home-introduction-section, .projects-section, .project-image-section').each(function() {

		Animations.global.push(() => {

			const slides = $(this).find('.home-introduction-slide, .content-column');

			slides.each(function() {

				const project = this.querySelector('.project-inner');

				if(project && !isTouchScreen()) {

					const mouse = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
					const translateX = gsap.quickSetter(project, 'x', 'px');
					const translateY = gsap.quickSetter(project, 'y', 'px');
					const translateMax = 100;
					const rotationX = gsap.quickSetter(project, 'rotationX', 'deg');
					const rotationY = gsap.quickSetter(project, 'rotationY', 'deg');
					const rotationMax = 25;
					const followMouse = () => {

						let position = {
							x: (mouse.x / window.innerWidth - 0.5),
							y: (mouse.y / window.innerHeight - 0.5),
						};

						translateX(-translateMax * position.x);
						translateY(-translateMax * position.y);
						rotationX(-rotationMax * position.y);
						rotationY(rotationMax * position.x);
					};

					gsap.ticker.add(followMouse);

					window.addEventListener('mousemove', e => {
						mouse.x = e.clientX;
						mouse.y = e.clientY;
					});

					$Elements.window.on('kill-follow-mouse', () => gsap.ticker.remove(followMouse));
				}
			});
		});
	});
};

$Elements.document.on(Events.page.enter, () => initBaseAnimations());
